import React from 'react';
import { Link } from 'react-router-dom';
import { FaCheckCircle, FaArrowRight, FaTrophy, FaUsers, FaMedal, FaHeart } from 'react-icons/fa';
import './About.css';

const FitnessConditioningTraining = () => {

    return (
        <div className="about-page">
            {/* Main About Section */}
            <section className="about-main section">
                <div className="container">
                    <div className="about-main-grid">
                        <div className="about-main-content">
                            <h2>Match Practice & Tournament Preparation</h2>
                            <p>
                                The Match Practice & Tournament Preparation program at Net Nest Badminton Sports Club is designed to prepare players for real competitive situations. This program bridges the gap between regular training and actual match performance by focusing on match exposure, tactical awareness, mental strength, and tournament readiness.
                            </p>
                            <p>
                                <h2>Program Overview</h2>
                                While technical skills are essential, true improvement happens when players learn to apply those skills under match pressure. Our Match Practice & Tournament Preparation program provides structured match play and strategic guidance, helping players gain confidence, consistency, and competitive edge.
                            </p>
                        </div>
                        <div className="about-main-images">
                            <img src="img/Match Practice & Tournament Preparation.jpg" alt="Badminton Court" className="main-image" />
                        </div>
                    </div>
                    <div className="about-main-grid">
                        <div className="about-main-content">
                            <h2>Regular Match Practice Sessions</h2>
                            <p>
                                Apply techniques in live match situations
                                <br></br>
                                Improve rally consistency and shot selection
                                <br></br>
                                Develop confidence and court awareness
                                <br></br>
                                Learn to adapt to different playing styles
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Tactical & Game Strategy Development</h2>
                            <p>
                                Match planning and point construction
                                <br></br>
                                Opponent analysis and adaptability
                                <br></br>
                                Singles and doubles positioning
                                <br></br>
                                Defensive and attacking transitions
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Tournament-Specific Training</h2>
                            <p>
                                Understanding tournament rules and formats
                                <br></br>
                                Match scheduling and warm-up routines
                                <br></br>
                                Recovery techniques between matches
                                <br></br>
                                Equipment preparation and court etiquette
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Mental Conditioning & Pressure Handling</h2>
                            <p>
                                Handling pressure and nervousness
                                <br></br>
                                Maintaining focus during crucial points
                                <br></br>
                                Building confidence and positive mindset
                                <br></br>
                                Managing wins and losses constructively
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Performance Analysis & Feedback</h2>
                            <p>
                                Strengths and areas of improvement
                                <br></br>
                                Tactical decision-making
                                <br></br>
                                Shot selection and movement efficiency
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Competitive Exposure & Confidence Building  </h2>
                            <p>
                                Match confidence
                                <br></br>
                                Competitive experience
                                <br></br>
                                Sportsmanship and discipline
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Who Should Join This Program?</h2>
                            <p>
                                Intermediate and advanced players
                                <br></br>
                                Tournament-focused athletes
                                <br></br>
                                Players aiming to improve match confidence
                                <br></br>
                                Athletes preparing for district, state, or open tournaments
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default FitnessConditioningTraining;
